module.exports = __webpack_public_path__ + "images/views-upsell/table.2678f921501e21b23b35.svg";